import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import { Modal, ModalBody } from 'reactstrap'

const ModalDrafts = ({ isOpen, toggle, onConfirm, isMobile, onRemove }) => {
  return (
    <>
      <Modal
        className="modal-dialog-centered p-5"
        isOpen={isOpen}
        toggle={toggle}
        centered
        data-testid="transaction-drafts-modal"
      >
        <ModalBody>
          <div>
            <P>
              Kami menemukan draft transaksi yang sebelumnya belum selesai.
              Apakah Anda ingin melanjutkan transaksi tersebut atau menghapus
              draft dan memulai yang baru?
            </P>
          </div>

          <div className="d-flex flex-row gap-3 mt-3">
            <CustomButton
              onClick={() => {
                onRemove()
              }}
              block
              outline
              color="primary"
              size={isMobile ? 'regular' : 'default'}
              className="btn-cancel"
              testId="transaction-drafts-remove-button"
            >
              Hapus
            </CustomButton>
            <CustomButton
              onClick={() => {
                onConfirm()
              }}
              block
              size={isMobile ? 'regular' : 'default'}
              color="primary"
              testId="transaction-drafts-confirm-button"
            >
              Lanjutkan
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalDrafts
